import { Collapse, CollapseItem, Upload, DatePicker, TimeSelect, Table, TableColumn, Tag, Input, Button, Select, Option, Popover } from 'element-ui';
import ResourceSvc from '@/services/resource.svc.js';
import { Switch as LSwitch } from '@/components/index';

import 'element-ui/lib/theme-chalk/index.css';
import { EventBus } from '@/services/Event.js';
const svc = new ResourceSvc();
import FilterBar from '@/components/admin/ranking/filter-bar/filter-bar.vue';

export default {
    name: 'SeriesType',
    props: ['selectedSerieIndex', 'selectedYearIndex'],
    components: {
        'filter-bar': FilterBar,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Table.name]: Table, [TableColumn.name]: TableColumn, [DatePicker.name]: DatePicker, [TimeSelect.name]: TimeSelect, [Tag.name]: Tag, [Input.name]: Input, [Select.name]: Select, [Option.name]: Option, [Upload.name]: Upload, [Button.name]: Button, [Popover.name]: Popover, LSwitch,
    },

    data() {
        return {
            yearCalculationsFrom: 0,
            perPage:10,
            organizations: [],
            distances: [],
            isProcessing: false,
            errorMessage: null,
            data: [],
            years: ["Initialization"],
            series: ["Initialization"],
            selectedYear: null,
            selectedYearLabel: null,
            selectedSerie: null,
            selectedSerieLabel: null,

            noRacesEntry: { name: "No races found", id: null, enumValue: 0 },
            races: [],
            racesInput: [],
            racesFiltered: [],

            addNewRaceMode: false,
        };
    },
    computed: {
        isPossibleCalulations() {
            return this.selectedYear >= this.yearCalculationsFrom;
        },
        isVisibleWorkflow() {
            return this.years && this.years.length && this.series && this.series.length;
        },
        isNotVisibleWorkflow() {
            return (!this.years || !this.years.length || !this.series || !this.series.length) && !this.isProcessing;
        }
    },
    methods: {
        showSuccess(message) {
            if (!message) {
                message = 'Operation success!';
            }

            this.$notify({
                message: message,
                type: 'success',
                timeout: 10000
            });
        },
        console(message) {
            if (console && console.log) {
                if (message) {
                    console.log(message);
                }
                else {
                    var date = new Date();
                    console.log("-------> " + date.getMinutes() + ":" + date.getSeconds());
                }
            }
        },
        setTabsInit() {
            var self = this;
            if (self.series && self.series.length) {
                self.selectedSerieLabel = self.series[self.selectedSerieIndex > -1 ? self.selectedSerieIndex : 0].shortLabel;
                self.selectedSerie = self.series[self.selectedSerieIndex > -1 ? self.selectedSerieIndex : 0].enumValue;
            }
            if (self.years && self.years.length) {
                self.selectedYear = self.years[self.selectedYearIndex > -1 ? self.selectedYearIndex : 0];
                self.selectedYearLabel = self.years[self.selectedYearIndex > -1 ? self.selectedYearIndex : 0] + '';
            }
            self.updateRaces();
        },
        init() {
            var self = this;
            self.isProcessing = true;
            self.races = [self.noRacesEntry];
            self.years = [];
            self.series = [];
            svc.getInitSeriesSettings().then(response => {
                self.isProcessing = false;
                if (response && response.body) {
                    self.series = response.body.series;
                    self.years = response.body.years
                    self.yearCalculationsFrom = response.body.yearCalculationsFrom
                    self.setTabsInit();
                }
                else {
                    self.errorMessage = "Something went wrong, please contact with dev team!";
                }
            }, () => {
                self.isProcessing = false;
                self.errorMessage = "Something went wrong, please contact with dev team!";
                });

            EventBus.$off('admin-ranking-filter-updated');
            EventBus.$on('admin-ranking-filter-updated', updateModel => self.searchForRaces(true, updateModel));

            EventBus.$off('admin-ranking-change-page');
            EventBus.$on('admin-ranking-change-page', (newPage, perPage) => { self.perPage = perPage; self.changePage(newPage, perPage); });
        },
        handleTabChangeSerie(tabIndex) {
            var self = this;
            this.selectedSerie = this.series[tabIndex].enumValue;
            this.selectedSerieLabel = this.series[tabIndex].shortLabel;
            this.updateRaces();

            if (self.selectedSerieIndex != tabIndex) {
                EventBus.$emit('ranking-layout-set-init-serie-index', tabIndex);
            }
        },
        handleTabChangeYear(tabIndex) {
            if (this.isProcessing) {
                return;
            }
            this.selectedYear = this.years[tabIndex];
            this.updateRaces();

            if (self.selectedYearIndex != tabIndex) {
                EventBus.$emit('ranking-layout-set-init-year-index', tabIndex);
            }
        },
        clearRaces() {
            var self = this;
            self.racesAll = [];
            self.racesFiltered = [];
            self.races = [];
            self.organizations = [];
            self.distances = [];
            self.addNewRaceMode = false;
        },
        searchForRaces(savePage, updateModel) {
            if (!savePage) {
                this.page = 1;
            }
            if (!updateModel) {
                this.racesFiltered = [...this.racesInput];
                this.races = [...this.racesFiltered].splice(0, this.perPage);
                return;
            }

            if (updateModel.startDateRange && updateModel.startDateRange.length > 1) {
                updateModel.startDateRange[0].setHours(1, 1, 1);
                updateModel.startDateRange[1].setHours(23, 59, 59);
            }
            
            var lowerfilterInput = updateModel.filterInput && updateModel.filterInput.length ? updateModel.filterInput.toLocaleLowerCase() : null;
            this.racesFiltered = [...this.racesInput
                .filter(race => {
                    return (!lowerfilterInput || race.raceName.toLocaleLowerCase().indexOf(lowerfilterInput) > -1 || race.id == lowerfilterInput) &&
                        (updateModel.selectedDistance == "All" || updateModel.selectedDistance == race.distance) &&
                        (updateModel.selectedTypeByEvent == "All" || updateModel.selectedTypeByEvent == race.typeByEvent) &&
                        (updateModel.selectedOrganizationName == "All" || updateModel.selectedOrganizationName == race.organizationName || updateModel.selectedOrganizationName == race.clubName) &&
                        (!updateModel.startDateRange || updateModel.startDateRange.length != 2 || (updateModel.startDateRange[0] <= race.startTime && updateModel.startDateRange[1] >= race.startTime));
                })];
            this.races = [...this.racesFiltered].splice(0, updateModel.perPage);
        },
        changePage(newPage, perPage) {
            var from = newPage ? (newPage - 1) * perPage : (this.page - 1) * perPage;
            if (from >= this.racesFiltered.length) {
                if (this.racesFiltered.length - perPage > 0) {
                    from = this.racesFiltered.length - perPage;
                }
                else {
                    from = 0;
                    this.page = 1;
                }
            }

            if (newPage) {
                this.races = [...this.racesFiltered].splice(from, perPage);
            }
            else {
                this.page = 1;
                this.races = [...this.racesFiltered].splice(from, perPage);
            }
        },
        prepareRacesFromResponse(response) {
            var self = this;
            if (response && response.body && response.body.isSuccess) {
                self.racesInput = response.body.data ? response.body.data : [self.noRacesEntry];
                self.organizations = [...new Set(self.racesInput.map(x => {
                    x.startTime = new Date(x.startTime);
                    return x.organizationName ? x.organizationName : x.clubName;
                }).filter(x => x))];

                self.organizations.unshift("All");
                self.distances = [...new Set(self.racesInput.map(x => { return x.distance }))];
                self.distances.unshift("All");
                EventBus.$emit('filter-bar-update');
            }
            else {
                self.errorMessage = response && response.body && response.body.errorMesssage ? response.body.errorMesssage : "Error while retrieving data.";
            }
        },
        updateRaces() {
            var self = this;
            self.clearRaces()
            if (self.selectedYear && self.selectedSerie) {
                self.isProcessing = true;
                svc.getRacesByYearAndSerieType(self.selectedSerie, self.selectedYear)
                    .then(response => {
                        self.prepareRacesFromResponse(response);
                        self.isProcessing = false;
                    },
                        () => {
                            self.errorMessage = "Error while retrieving data.";
                            self.isProcessing = false;
                        });
            }

            return self.races.length;
        },
        addNewRaceSwitch() {
            self = this;
            if (self.addNewRaceMode) {
                self.addNewRaceMode = false;
                self.updateRaces();
                return;
            }

            self.isProcessing = true;
            self.clearRaces();
            self.addNewRaceMode = true;
            svc.getRacesExceptSerieType(self.selectedSerie, self.selectedYear)
                .then(response => {
                    self.prepareRacesFromResponse(response);
                    self.isProcessing = false;
                },
                    () => {
                        self.errorMessage = "Something went wrong, please contact with dev team!";
                        self.isProcessing = false;
                    }
                )
        },
        removeRaceAndUpdateArrays(race) {
            var self = this;
            self.racesInput = self.racesInput.filter(raceIn => { return raceIn != race });
            if (!self.racesInput.length) {
                self.racesInput = [self.noRacesEntry];
            }
            EventBus.$emit('filter-bar-re-search');
        },
        changeRaceSeriesConfirmed(race, seriesEnum) {
            var self = this;
            self.isProcessing = true;
            svc.setSerieTypeForRace(seriesEnum, race.id, self.selectedSerie)
                .then(response => {
                    if (response && response.body && response.body.isSuccess) {
                        self.removeRaceAndUpdateArrays(race);
                    }
                    else {
                        self.$showError(response && response.body && response.body.message ? response.body.message : "Error while saving changes", 100000);
                    }
                    self.isProcessing = false;
                },
                    () => {
                        self.$showError("Error while saving changes", 100000);
                        self.isProcessing = false;
                    })
        },
        changeNationalChampionshipConfirmed(race) {
            var self = this;
            self.isProcessing = true;
            svc.postSwitchIsNationalChampionship(race.id)
                .then(response => {
                    if (response && response.body && response.body.isSuccess) {
                        self.updateRaces();
                    }
                    else {
                        self.$showError(response && response.body && response.body.message ? response.body.message : "Error while saving changes", 100000);
                    }
                    self.isProcessing = false;
                },
                    () => {
                        self.$showError("Error while saving changes", 100000);
                        self.isProcessing = false;
                    })
        }
    },
    mounted() {
        this.init();
    }
};



// WEBPACK FOOTER //
// ./src/components/admin/ranking/series-type/series-type.js